import { useState } from 'react'
import type { UserManagementEditConfirmKind } from '../constants/editPageUi'
import type { UserRole } from '../types'

export function useUserManagementEditDialogs() {
  const [confirmOpen, setConfirmOpen] = useState<UserManagementEditConfirmKind | null>(null)
  const [assignRoleOpen, setAssignRoleOpen] = useState(false)
  const [editingRole, setEditingRole] = useState<UserRole | null>(null)
  const [removingRoleId, setRemovingRoleId] = useState<number | null>(null)
  const [finMgrRoleId, setFinMgrRoleId] = useState<number | null>(null)
  const [impersonateTarget, setImpersonateTarget] = useState<{
    roleId: number
    roleName: string
  } | null>(null)
  const [pendingSalesRole, setPendingSalesRole] = useState('')

  const closeAssignRoleModal = () => {
    setAssignRoleOpen(false)
    setEditingRole(null)
  }

  const resetSalesRoleFlow = () => {
    setPendingSalesRole('')
    setConfirmOpen(null)
  }

  return {
    confirmOpen,
    setConfirmOpen,
    assignRoleOpen,
    setAssignRoleOpen,
    editingRole,
    setEditingRole,
    closeAssignRoleModal,
    removingRoleId,
    setRemovingRoleId,
    finMgrRoleId,
    setFinMgrRoleId,
    impersonateTarget,
    setImpersonateTarget,
    pendingSalesRole,
    setPendingSalesRole,
    resetSalesRoleFlow,
  }
}
